<template>
  <div>
    <v-row>
      <p class="ma-4 pa-1">{{ label }}</p>
      <vue-timepicker
        v-model="data.Records[0].value"
        class="ma-3 vue-timepicker"
        :minute-interval="interval"
        hide-clear-button
      ></vue-timepicker>
    </v-row>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  components: {
    "vue-timepicker": VueTimepicker,
  },
  props: {
    record: Object,
    label: String,
    init: String,
    rule: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: null, form_id: 0, form_type: 3, menu: false }],
      },
      interval: "",
    };
  },
  async mounted() {
    this.data.Records[0].value = this.init;
    let tmp = this.rule.split(",");
    if (tmp[1] == 0) {
      this.interval = "";
    } else if (tmp[1] == 1) {
      this.interval = "10";
    } else if (tmp[1] == 2) {
      this.interval = "15";
    } else if (tmp[1] == 3) {
      this.interval = "30";
    }
  },
};
</script>

<style></style>
